module.exports = __webpack_public_path__ + "static/media/DSC_0091.213b7bfa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/DSC_0091.jpg
// module id = 630
// module chunks = 0